import React from "react";
import Dashboard from "../../common/Dashboard";
import DashboardConfig from "../system-admin/Dashboard/DashboardConfig";

export default function AM_II_Dashboard() {
  return (
    <Dashboard sidebarType="A.M -II">
      <DashboardConfig />
    </Dashboard>
  );
}
